import { useState, useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import {
  Box,
  Text,
  Button,
  Flex,
  Heading,
  Image,
  FormControl,
  FormLabel,
  Input,
  Stack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useToast,
  Badge,
  Checkbox,
} from "@chakra-ui/react";
import MenuPrincipal from "../../Components/Menu";
import api from "../../services/api";
import EsqueceuSenhaModal from "../../Components/EsqueceuSenha";
import { RedactionContext } from "../../contexts/Redacoes";

const RedacaoAluno = () => {
  const toast = useToast();

  const [logged, setLogged] = useState(null);
  const [showLoginModal, setShowLoginModal] = useState();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [user, setUser] = useState();
  const [redactions, setRedactions] = useState();
  const [isLoggedIn, setIsLoggedIn] = useState();
  const [isUserLoggedIn, setIsUserLoggedIn] = useState();
  const [showEsqueceuSenhaModal, setShowEsqueceuSenhaModal] = useState(false);
  const { getRedactionUserTemasApi, toggleRedactionApi } =
    useContext(RedactionContext);
  const [redaction, setRedaction] = useState(false);
  const [done, setDone] = useState(false);

  function getInfoRedaction() {
    api
      .get(`get/simulator/redaction/info`)
      .then((response) => {
        console.log(response);
        setRedaction(response.data?.[0]);
      })
      .catch((error) => {
        console.log(error);
      });
  }
  const handleLogin = async () => {
    const data = {
      email: email,
      password: password,
    };
    try {
      const response = await api.post("auth/login", data);

      const loggedUser = response.data.user;
      const token = response.data.token;

      localStorage.setItem("user", JSON.stringify(loggedUser));
      localStorage.setItem("token", token);

      setUser(loggedUser);
      setIsLoggedIn(true);
      if (response.status === 200) {
        setIsUserLoggedIn(true);
        setIsLoggedIn(true);

        setShowLoginModal(false);
      }
      window.location.reload();
      return response;
    } catch (error) {
      JSON.stringify(error);
      console.log(error.data);
      toast({
        title: "Verifique o email e senha",
        status: "error",
        isClosable: true,
      });
      return error;
    }
  };

  function userLogged() {
    const user = JSON.parse(localStorage.getItem("user"));
    const token = localStorage.getItem("token");

    const headers = {
      Authorization: `Bearer ${token}`,
    };

    if (user === null) {
      setShowLoginModal(true);
    } else {
      api
        .get(`/user/${user.id}/status`, { headers })
        .then((response) => {
          setLogged(true);
        })
        .catch((error) => {
          setShowLoginModal(true);
          if (error.response && error.response.status === 401) {
            setShowLoginModal(true);
          } else {
            setLogged(true);
          }
        });
    }
  }

  const handleEsqueceuSenha = () => {
    setShowLoginModal(false);
    setShowEsqueceuSenhaModal(true);
  };
  async function getRedactionTemas() {
    try {
      const response = await getRedactionUserTemasApi();

      setRedactions(response.data[0]);

      console.log(response.data[0]);
    } catch (error) {}
  }

  const toggleRedaction = async (id) => {
    try {
      const response = await toggleRedactionApi({
        redaction_id: id,
      });
      setRedactions((prev) =>
        prev.map((r) => (r.id === id ? { ...r, done: response.data.done } : r))
      );
      toast({
        title: "Redação realizada com sucesso",
        status: "success",
        duration: 5000,
        isClosable: true,
      });
    } catch (error) {
      toast({
        title: "Algo deu errado",
        description: "Não foi possível atualizar a redação. Tente novamente.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  useEffect(() => {
    getRedactionTemas();
    userLogged();
    getInfoRedaction();
  }, []);

  return (
    <>
      <MenuPrincipal isUserLoggedIn={isUserLoggedIn} />

      <Box
        bg="#050f40"
        h="80px"
        display="flex"
        justifyContent={"center"}
        color={"white"}
        textAlign={"center"}
      >
        <Heading>Área de Redações</Heading>
      </Box>
      <Box my={4} width="90vw" mx="auto">
        <Box
          borderWidth="1px"
          borderRadius="md"
          p={4}
          width="100%"
          color="black"
          backgroundColor="white"
        >
          <Heading as="h2" size="lg" mb={2}>
            Área da Redação
          </Heading>
          <Badge colorScheme="blue" fontSize="0.9em" mb={4} whiteSpace="normal">
            Hora de pegar seu papel e caneta e praticar sua redação!
          </Badge>

          {redaction && redaction.file_path ? (
            <Box mb={4}>
              <Text color={"#000000"} fontSize="lg" mb={2}>
                Para fazer a redação, baixe o arquivo abaixo:
              </Text>
              <Button
                as="a"
                href={`https://api.colegionaval.com.br/storage/app/public/${redaction.file_path}`}
                colorScheme="blue"
                mt={1}
                target="_blank"
                rel="noopener noreferrer"
              >
                Download arquivo de redação
              </Button>
            </Box>
          ) : null}
          {redactions?.map((redaction) => (
            <>
              <Heading as="h3" size="md" mb={2}>
                Tema proposto:
              </Heading>
              <Text fontWeight="bold" mb={4}>
                {redaction?.theme_redacao}
              </Text>

              <Box
                mb={4}
                dangerouslySetInnerHTML={{ __html: redaction?.info }}
              />
              <Checkbox
                isChecked={redaction?.done}
                onChange={() => toggleRedaction(redaction.id)}
              >
                Marcar como feita
              </Checkbox>
              <Text fontStyle="italic" color="gray.600" py={5}>
                💡 Encontre um lugar tranquilo, e escreva como se estivesse no
                dia da prova. Sem distrações!
              </Text>
              <hr />
            </>
          ))}
        </Box>
      </Box>
      {showLoginModal && (
        <Modal isOpen={showLoginModal} onClose={() => setShowLoginModal(false)}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Login</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <FormControl>
                <FormLabel>Email</FormLabel>
                <Input
                  type="email"
                  placeholder="E-mail"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </FormControl>
              <FormControl mt={4}>
                <FormLabel>Password</FormLabel>
                <Input
                  type="password"
                  placeholder="senha"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </FormControl>
              <Button
                variant="link"
                color="blue.500"
                onClick={handleEsqueceuSenha}
              >
                Esqueceu a Senha?
              </Button>
            </ModalBody>

            <ModalFooter>
              <Button colorScheme="blue" mr={3} onClick={handleLogin}>
                Login
              </Button>
              <Button variant="ghost" onClick={() => setShowLoginModal(false)}>
                Cancelar
              </Button>
            </ModalFooter>
            <Box maxW={"350px"}>
              <Stack
                ml={5}
                pb={2}
                direction={{ base: "column", sm: "row" }}
                align={"start"}
                justify={"space-between"}
              >
                <Text>Ainda não tem Cadastro?</Text>

                <Link to={"/cadastro"}>
                  <Text color={"#FAB929"} fontWeight={"bold"}>
                    Cadastre-se
                  </Text>
                </Link>
              </Stack>
            </Box>
          </ModalContent>
        </Modal>
      )}

      <EsqueceuSenhaModal
        isOpen={showEsqueceuSenhaModal}
        onClose={() => setShowEsqueceuSenhaModal(false)}
      />
    </>
  );
};

export default RedacaoAluno;
